import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { string } from 'prop-types';
import { useProduct } from '@magento/peregrine/lib/talons/RootComponents/Product/useProduct';
import { fullPageLoadingIndicator } from '@magento/venia-ui/lib/components/LoadingIndicator';
import ErrorView from '@magento/venia-ui/lib/components/ErrorView';
import { StoreTitle, Meta } from '@magento/venia-ui/lib/components/Head';
import ProductFullDetail from '@magento/venia-ui/lib/components/ProductFullDetail';
import mapProduct from '@magento/venia-ui/lib/util/mapProduct';
/*
 * As of this writing, there is no single Product query type in the M2.3 schema.
 * The recommended solution is to use filter criteria on a Products query.
 * However, the `id` argument is not supported. See
 * https://github.com/magento/graphql-ce/issues/86
 * TODO: Replace with a single product query when possible.
 */

var Product = function Product(props) {
  var productType = props.__typename;
  var talonProps = useProduct({
    mapProduct: mapProduct
  });
  var error = talonProps.error,
      loading = talonProps.loading,
      product = talonProps.product;
  if (loading && !product) return fullPageLoadingIndicator;
  if (error && !product) return React.createElement(ErrorView, null);

  if (!product) {
    return React.createElement("div", {
      className: "container mt-10 xl_mt-20"
    }, React.createElement("h3", {
      className: "w-4/6 text-black"
    }, React.createElement(FormattedMessage, {
      id: 'product.outOfStockTryAgain',
      defaultMessage: 'This Product is currently out of stock. Please try again later.'
    })));
  }

  return React.createElement(Fragment, null, React.createElement(StoreTitle, {
    hideStoreName: true
  }, product !== null && product !== void 0 && product.meta_title ? product === null || product === void 0 ? void 0 : product.meta_title : product === null || product === void 0 ? void 0 : product.name), React.createElement(Meta, {
    name: "viewport",
    content: "width=device-width, initial-scale=1.0 user-scalable=yes",
    "data-react-helmet": "true"
  }), React.createElement(Meta, {
    name: "description",
    content: product.meta_description
  }), React.createElement(Meta, {
    name: "keywords",
    content: product === null || product === void 0 ? void 0 : product.meta_keyword
  }), React.createElement(ProductFullDetail, {
    product: product
  }));
};

Product.propTypes = {
  __typename: string.isRequired
};
export default Product;